import React from 'react';
import { useDispatch } from 'react-redux';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import styles from './migrate-second-step-details.module.scss';
import { useGetTheme } from '../../../../../../../hooks/useGetTheme';
import Header from '../../../../../../../components/Stake/header';
import OmIcon from '../../../../../../../assets/images/tokens/om.svg';
import * as omStakeActions from '../../../../../../../actions/om-stake-actions';

const MigrateSecondStepDetails = () => {
  const colors = useGetTheme();
  const dispatch = useDispatch();

  return (
    <>
      <Header icon={OmIcon} title='OM-Migration' />
      <CardContent
        style={{
          padding: '0',
          display: 'flex',
          position: 'relative',
          zIndex: 1,
          flexGrow: 1,
        }}
      >
        <div className={styles.container} style={{ color: colors.text }}>
          <div className={styles.description}>
            <span>IMPORTANT!</span> You are now ready to complete Stage 2 of the migration process.
            During this stage, you will have to submit 4 different transactions to the blockchain.
            The step by step process and details behind these transactions are as follows:
            <br />
            <br />
            <b>Step 1.</b> Claim rewards earned from staking pool 2 during the 8 day unstaking
            period, and place them in escrow. These rewards become payable to you only if you
            complete Step 4 in this process.
            <br />
            <br />
            <b>Step 2.</b> Withdraw V1 OM tokens from staking pool v1, in preparation to be migrated
            to V2 OM token and staked in staking pool V2.
            <br />
            <br />
            <b>Step 3.</b> Approve spending of V1 OM tokens on the migrator contract.
            <br />
            <br />
            <b>Step 4.</b> Migrate V1 OM tokens to V2 OM tokens, and stake them on staking pool V2.
            This step also pushes the OM rewards placed in escrow on Step 1 into your staking
            balance on pool V2.
          </div>
          <div className={styles.footer} style={{ backgroundColor: colors.cardBackgroundTint }}>
            <Button
              className={styles.button}
              onClick={() => dispatch(omStakeActions.migrateSecondStepSend())}
              variant='contained'
              color='secondary'
            >
              Next
            </Button>
          </div>
        </div>
      </CardContent>
    </>
  );
};

export default MigrateSecondStepDetails;
